import React from 'react';
import AboutNavHeader from '../components/about/AboutNavHeader';
import UserBasedNav from './UserBasedNav';

interface LocationUserBasedNavProps {
  locationPathname: string;
}

const LocationUserBasedNav: React.FC<LocationUserBasedNavProps> = ({
                                                                     locationPathname
                                                                   }) => {

  switch (locationPathname) {
    case "/":
      return null;
    case '/about':
      return <AboutNavHeader/>;
    default:
      return <UserBasedNav/>;
  }
};

export default LocationUserBasedNav;
